import type { EVENT_VARIABLE_TYPE, ResolvedValueVariable, TypeInstanceMap } from '@lighthouse/core'
import {
    type DateVariableValue,
    EVENT_VARIABLE_VALUE,
    type FieldType,
    ImageVariableValue,
    type ValueVariable,
    VariableType
} from '@lighthouse/core'

import { FieldIconTypeMap, innerTypeToFieldTypeIconMap, SystemFieldIconTypeMap } from '../../constants'
import type { VariableTree2 } from './types'

export const ignoreEleId = 'default-custom-value'

export const pageSourceVariableType = ['parentPage', 'page']

export const FILTER_DATE_SYSTEM_LIST_1: DateVariableValue[] = [
    'NOW',
    'TODAY',
    'TOMORROW',
    'YESTERDAY',
    'THIS_WEEK',
    'LAST_WEEK',
    'THIS_MONTH',
    'LAST_MONTH',
    'THIS_YEAR',
    'PAST_SEVEN_DAYS',
    'FUTURE_SEVEN_HEAVENS',
    'PAST_THIRTY_DAYS',
    'FUTURE_THIRTY_HEAVENS'
]

export const FILTER_DATE_SYSTEM_LIST_2: DateVariableValue[] = [
    'TODAY',
    'TOMORROW',
    'YESTERDAY',
    'THIS_WEEK',
    'BEFORE_SOMEWHAT_DAYS',
    'AFTER_SOMEWHAT_DAYS'
]

export const AggregationInnerTypeToFieldType: Record<TypeInstanceMap, FieldType> = {
    TEXT: 'text',
    NULL: 'text',
    DATE: 'date',
    BOOL: 'checkbox',
    NUMBER: 'number',
    RICH_TEXT: 'notes',
    ARRAY: 'text',
    RUNTIME: 'text'
}

export const variableFieldInfoMap: Record<
    FieldType,
    {
        name: string
        icon: string
    }
> = {
    id: {
        name: '输入具体值',
        icon: FieldIconTypeMap['id']
    },
    text: {
        name: '输入具体值',
        icon: FieldIconTypeMap['text']
    },
    number: {
        name: '输入具体值',
        icon: FieldIconTypeMap['number']
    },
    email: {
        name: '输入具体值',
        icon: FieldIconTypeMap['email']
    },
    phoneNumber: {
        name: '输入具体值',
        icon: FieldIconTypeMap['phoneNumber']
    },
    url: {
        name: '输入具体值',
        icon: FieldIconTypeMap['url']
    },
    select: {
        name: '选择选项',
        icon: FieldIconTypeMap['select']
    },
    date: {
        name: '选择具体日期',
        icon: FieldIconTypeMap['date']
    },
    file: {
        name: '',
        icon: ''
    },
    video: {
        name: '',
        icon: ''
    },
    person: {
        name: '选择人员',
        icon: FieldIconTypeMap['person']
    },
    notes: {
        name: '输入具体值',
        icon: FieldIconTypeMap['notes']
    },
    formula: {
        name: '输入具体值',
        icon: FieldIconTypeMap['formula']
    },
    role: {
        name: '选择角色',
        icon: FieldIconTypeMap['role']
    },
    checkbox: {
        name: '选择是或否',
        icon: FieldIconTypeMap['checkbox']
    },
    department: {
        name: '选择部门',
        icon: FieldIconTypeMap['department']
    },
    aggregation: {
        name: '',
        icon: ''
    },
    singleSelect: {
        name: '选择账号状态',
        icon: SystemFieldIconTypeMap['STATUS']
    },
    parentDepartment: {
        name: '选择部门',
        icon: FieldIconTypeMap['parentDepartment']
    },
    runtime: {
        name: '',
        icon: ''
    }
}

export const DEFAULT_VALUE_VARIABLE: ValueVariable = { type: VariableType.VALUE }

export const DEFAULT_RESOLVED_VALUE_VARIABLE: ResolvedValueVariable = { type: VariableType.RESOLVED }

export const CURRENT_PAGE = 'CURRENT_PAGE'

export const ruleOptions = [
    {
        label: '所有',
        value: 'AND'
    },
    {
        label: '任一',
        value: 'OR'
    }
]

export const commonEventVariableValue: VariableTree2[] = [
    {
        type: VariableType.EVENT,
        icon: innerTypeToFieldTypeIconMap['TEXT'],
        label: '事件名称',
        value: EVENT_VARIABLE_VALUE.EVENT_NAME,
        fieldInnerType: 'TEXT'
    },
    {
        type: VariableType.EVENT,
        icon: innerTypeToFieldTypeIconMap['TEXT'],
        label: '事件类型',
        value: EVENT_VARIABLE_VALUE.EVENT_TYPE,
        fieldInnerType: 'TEXT'
    },
    {
        type: VariableType.EVENT,
        icon: innerTypeToFieldTypeIconMap['TEXT'],
        label: '客户端类型',
        value: EVENT_VARIABLE_VALUE.CLIENT_TYPE,
        fieldInnerType: 'TEXT'
    }
]

export const collectEventTypeName: Record<EVENT_VARIABLE_TYPE, string> = {
    PAGE_VISIT: '页面访问事件',
    // WECHAT_SHARE: '微信分享事件',
    BUTTON_CLICK: '按钮点击事件'
}

export const eventTypeIcon: Record<EVENT_VARIABLE_TYPE, string> = {
    PAGE_VISIT: 'PageEvent',
    // WECHAT_SHARE: 'WeChatLogo',
    BUTTON_CLICK: 'ClickButton'
}

export const eventOption: Record<EVENT_VARIABLE_TYPE, VariableTree2[]> = {
    PAGE_VISIT: [
        {
            type: VariableType.EVENT,
            icon: innerTypeToFieldTypeIconMap['TEXT'],
            label: '页面名称',
            value: EVENT_VARIABLE_VALUE.PAGE_NAME,
            fieldInnerType: 'TEXT'
        },
        ...commonEventVariableValue
    ],
    // WECHAT_SHARE: [{
    //     icon: innerTypeToFieldTypeIconMap['TEXT'],
    //     title: '页面名称',
    //     id: EVENT_VARIABLE_VALUE.PAGE_NAME,
    //     type: VariableType.EVENT
    // }, ...commonEventVariableValue],
    BUTTON_CLICK: [
        {
            type: VariableType.EVENT,
            icon: innerTypeToFieldTypeIconMap['TEXT'],
            label: '组件名称',
            value: EVENT_VARIABLE_VALUE.BLOCK_NAME,
            fieldInnerType: 'TEXT'
        },
        ...commonEventVariableValue
    ]
}

export const imageVariableNameMap = {
    [ImageVariableValue.IMAGE_NAME]: '图片名称',
    [ImageVariableValue.IMAGE_URL]: '图片URL',
    [ImageVariableValue.IMAGE_INDEX]: '图片索引'
}
